import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { C, btnPrimary, softShadow } from "../lib/theme";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="bg-white rounded-3xl p-10 max-w-md w-full text-center" style={softShadow} data-testid="payment-cancel">
        <XCircle className="w-16 h-16 mx-auto mb-5" style={{ color: C.MUTED }} />
        <h1 className="font-display text-3xl font-extrabold mb-2" style={{ color: C.INK }}>Pagamento annullato</h1>
        <p className="mb-8" style={{ color: "#6b665d" }}>Non hai completato il pagamento della caparra. La prenotazione non è confermata.</p>
        <Link to="/" className={`${btnPrimary} inline-flex`}>Torna alla home</Link>
      </div>
    </div>
  );
}
